import { Button } from '@/lib';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@/assets/icons/close.svg?react';

interface IErrorStatus {
  error?: FetchBaseQueryError | SerializedError | string;
  handleTryAgain?: () => void;
}

function isString(error: FetchBaseQueryError | SerializedError | string): error is string {
  return typeof error === 'string' || error instanceof String;
}

function isFetchError(error: FetchBaseQueryError | SerializedError): error is FetchBaseQueryError {
  return (error as FetchBaseQueryError).data !== undefined;
}

export const ErrorStatus: FC<IErrorStatus> = ({ error, handleTryAgain }) => {
  const { t } = useTranslation('data_source_edit');

  const retrieveDisplayMessage = (error: FetchBaseQueryError | SerializedError | string): string => {
    if (isString(error)) {
      return String(error);
    }

    if (isFetchError(error)) {
      return error.data as string;
    } else {
      return String(error.message);
    }
  };

  return (
      <div className='flex h-52 flex-col items-center justify-center gap-6 rounded-md border bg-red-50 p-6'>
        <CloseIcon className='text-red-900'/>
        <p className='mb-2 rounded-md text-xl font-medium  text-red-900'>{t('file.name_and_file.file_upload_input_component.something_went_wrong')}</p>
        {error && <p className='mb-2 rounded-md text-sm font-medium text-red-900'>{retrieveDisplayMessage(error)}</p>}
        {handleTryAgain && (
          <div className='flex justify-center'>
            <Button intent='primary' onClick={handleTryAgain} className='w-24 bg-red-700 text-white-100 '>
              {t('file.name_and_file.file_upload_input_component.try_again')}
            </Button>
          </div>
        )}
      </div>
  );
};
